<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Awards', to: { path: '/awards' } },
        { name: 'Award Info', to: { path: '/awards/award-info' } },
        { name: 'Edit', to: { path: '/awards/award-info/edit' } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯Award Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!-- Create Edit Award Info -->
    <AwardCreateEdit></AwardCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import AwardCreateEdit from '@/views/D_Awards/c/AwardCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    AwardCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('award', ['award']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getAward(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('award', {
      getAward: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push('/awards');
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.award).then(() => {
          this.$router.push({ name: 'AwardList' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
